import React, { useState } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Button,
  Collapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

export default function AppNavbar(props) {

    const { white } = props;

    const [ collapseClasses, setCollapseClasses ] = useState("navbar-mobile");
    const [ collapseOpen, setCollapseOpen ] = useState(false);

    const toggleNavbar = () => setCollapseOpen(!collapseOpen);

    const onEntering = () => setCollapseClasses("navbar-mobile collapsing-in");
    const onEntered = () => setCollapseClasses("navbar-mobile")

    const onExiting = () => setCollapseClasses("navbar-mobile collapsing-out");
    const onExited = () => setCollapseClasses("navbar-mobile");

    const NavClasses = classnames({
        'navbar-main': true,
        'navbar-light': true,
    })

    return (
        <header className="header-global">
            <Navbar
                className={NavClasses}
                expand="lg"
                id="navbar-main"
                >
                <Container>
                    <div className="d-flex justify-content-between align-items-center">
                        <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                            <img
                                alt="Club Apps | A new way to Manage your Membership"
                                src={
                                    white ? require("assets/images/club-apps-brand.svg")
                                    : require("assets/images/club-apps-brand-white.svg")
                                }
                            />
                        </NavbarBrand>
                        <button className="navbar-toggler"  onClick={toggleNavbar}>
                            <span className="navbar-toggler-icon" />
                        </button>
                        <Collapse
                            isOpen={collapseOpen}
                            className={collapseClasses}
                            onEntering={onEntering}
                            onEntered={onEntered}
                            onExiting={onExiting}
                            onExited={onExited}
                            >
                            <div className="navbar-mobile-header bg-secondary">
                                <Row className="align-items-center">
                                    <Col className="mobile-header-col" xs="6">
                                        <h5 className="heading">
                                            Discover
                                        </h5>
                                    </Col>
                                    <Col className="mobile-close" xs="6">
                                        <button className="navbar-toggler" onClick={toggleNavbar}>
                                            <span />
                                            <span />
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                            <div className="navbar-mobile-body">
                                <Row>
                                    <Col className="mobile-body-col" xs="12">
                                        <Link to="/overview" className="d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-primary">
                                                <i className="ni ni-app" />
                                            </div>
                                            <h6 className="ml-3 mb-0">
                                                Overview
                                            </h6>
                                        </Link>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mobile-body-col" xs="12">
                                        <Link to="/features" className="d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-success">
                                                <i className="ni ni-spaceship" />
                                            </div>
                                            <h6 className="mb-0 ml-3">
                                                Features
                                            </h6>
                                        </Link>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mobile-body-col" xs="12">
                                        <Link to="/pricing" className="d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-warning">
                                                <i className="ni ni-tag" />
                                            </div>
                                            <h6 className="mb-0 ml-3">
                                                Pricing
                                            </h6>
                                        </Link>
                                    </Col>
                                </Row>
                            </div>
                            <div className="navbar-mobile-header bg-secondary">
                                <Row>
                                    <Col className="mobile-header-col" xs="12">
                                        <h5 className="heading">
                                            Company
                                        </h5>
                                    </Col>
                                </Row>
                            </div>
                            <div className="navbar-mobile-body">
                                <Row>
                                    <Col className="mobile-body-col" xs="12">
                                        <Link to="/about-us" className="d-flex align-items-center">
                                            <h6 className="mb-0 text-muted">
                                                About Us
                                            </h6>
                                        </Link>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mobile-body-col" xs="12">
                                        <Link to="/jobs" className="d-flex align-items-center">
                                            <h6 className="mb-0 text-muted">
                                                Jobs
                                            </h6>
                                        </Link>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mobile-body-col" xs="12">
                                        <Link to="/contact" className="d-flex align-items-center">
                                            <h6 className="mb-0 text-muted">
                                                Contact Us
                                            </h6>
                                        </Link>
                                    </Col>
                                </Row>
                            </div>
                            <div className="navbar-mobile-body bg-secondary mb-1">
                                <NavLink
                                    href="https://support.clubapps.org/"
                                    target="_blank"
                                    title="Visit our Support Center"
                                    className="login-nav-link text-warning"
                                    >
                                    <i className="ni ni-bulb-61 mr-3" />
                                    <span>
                                        Support Center
                                    </span>
                                </NavLink>
                            </div>
                            <div className="navbar-mobile-body bg-secondary">
                                <NavLink
                                    href="https://clubapps.org/"
                                    target="_blank"
                                    title="Login to Club Apps"
                                    className="login-nav-link text-primary"
                                    >
                                    <i className="fa fa-sign-in mr-3" />
                                    <span>
                                        Login
                                    </span>
                                </NavLink>
                            </div>
                        </Collapse>
                        <Nav className="navbar-nav-hover align-items-center d-none d-lg-flex" navbar>
                            <UncontrolledDropdown nav>
                                <DropdownToggle nav>
                                    <i className="ni ni-compass-04 d-lg-none mr-1" />
                                    <span className="nav-link-inner--text">Discover</span>
                                    <i className="ni ni-fat-add d-lg-none ml-3" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-xl">
                                    <DropdownItem to="/overview" tag={Link}>
                                        <Media className="d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-primary rounded-circle">
                                                <i className="ni ni-app" />
                                            </div>
                                            <Media body className="ml-3">
                                                <h6 className="heading text-primary mb-0 mb-md-1">
                                                    Overview
                                                </h6>
                                                <p className="description d-none d-md-inline-block mb-0">
                                                    Discover why clubs all over the country are choosing Club Apps to manage their membership.
                                                </p>
                                            </Media>
                                        </Media>
                                    </DropdownItem>
                                    <DropdownItem to="/features" tag={Link}>
                                        <Media className="d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-success">
                                                <i className="ni ni-spaceship" />
                                            </div>
                                            <Media body className="ml-3">
                                                <h6 className="heading text-success mb-0 mb-md-1">
                                                    Features
                                                </h6>
                                                <p className="description d-none d-md-inline-block mb-0">
                                                    Learn about how our flagship application's features can help launch your organization in to the future.
                                                </p>
                                            </Media>
                                        </Media>
                                    </DropdownItem>

                                    <DropdownItem

                                        tag={Link}
                                        to="/pricing"
                                        >
                                        <Media className="d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-warning rounded-circle">
                                                <i className="ni ni-tag" />
                                            </div>
                                            <Media body className="ml-3">
                                                <h5 className="heading text-warning mb-0 mb-md-1">
                                                    Pricing
                                                </h5>
                                                <p className="description d-none d-md-inline-block mb-0">
                                                    Club Apps offers three subscription levels to fit your organizations needs. Find out what package fits your goals.
                                                </p>
                                            </Media>
                                        </Media>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <UncontrolledDropdown nav>
                                <DropdownToggle nav>
                                    <i className="ni ni-shop d-lg-none mr-1" />
                                    <span className="nav-link-inner--text">Company</span>
                                    <i className="ni ni-fat-add d-lg-none ml-3" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg">
                                    <DropdownItem to="/about-us" tag={Link}>
                                        ABOUT US
                                    </DropdownItem>
                                    {/*}
                                    <DropdownItem to="/our-team" tag={Link}>
                                        OUR TEAM
                                    </DropdownItem>
                                    */}
                                    <DropdownItem to="/jobs" tag={Link}>
                                        JOBS
                                    </DropdownItem>
                                    <DropdownItem to="/contact" tag={Link}>
                                        CONTACT US
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <NavItem>
                                <NavLink
                                    href="https://support.clubapps.org/"
                                    target="_blank"
                                    title="Visit our Support Center"
                                    >
                                    <i className="ni ni-bulb-61 d-lg-none mr-1" />
                                    <span className="nav-link-inner--text">
                                        Support
                                    </span>
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <Nav className="ml-auto align-items-center d-none d-lg-block" navbar>
                            {/*}
                            <NavItem>
                                <NavLink
                                    className="nav-link-icon"
                                    href=""
                                    id="tooltip333589074"
                                    target="_blank"
                                    >
                                    <i className="fa fa-facebook-square" />
                                    <span className="nav-link-inner--text d-lg-none ml-2">
                                        Facebook
                                    </span>
                                </NavLink>
                                <UncontrolledTooltip className="d-none d-lg-block" delay={0} target="tooltip333589074">
                                    Like us on Facebook
                                </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className="nav-link-icon"
                                    href=""
                                    id="tooltip356693867"
                                    target="_blank"
                                    >
                                    <i className="fa fa-instagram" />
                                    <span className="nav-link-inner--text d-lg-none ml-2">
                                        Instagram
                                    </span>
                                </NavLink>
                                <UncontrolledTooltip className="d-none d-lg-block" delay={0} target="tooltip356693867">
                                    Follow us on Instagram
                                </UncontrolledTooltip>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className="nav-link-icon"
                                    href=""
                                    id="tooltip184698705"
                                    target="_blank"
                                    >
                                    <i className="fa fa-twitter-square" />
                                    <span className="nav-link-inner--text d-lg-none ml-2">
                                        Twitter
                                    </span>
                                </NavLink>
                                <UncontrolledTooltip className="d-none d-lg-block" delay={0} target="tooltip184698705">
                                    Follow us on Twitter
                                </UncontrolledTooltip>
                            </NavItem>
                            */}
                            <NavItem className="ml-lg-4 mt-3 mt-lg-0">
                                <Button
                                    className="btn-neutral btn-icon w-100 w-lg-auto"
                                    color="default"
                                    href="https://clubapps.org"
                                    target="_blank"
                                    >
                                    <span className="btn-inner--icon">
                                        <i className="fa fa-sign-in mr-2" />
                                    </span>
                                    <span className="nav-link-inner--text ml-1">
                                        Login
                                    </span>
                                </Button>
                            </NavItem>
                        </Nav>
                    </div>
                    {white &&
                        <hr />
                    }
                </Container>
            </Navbar>
        </header>
    );
}
